import React from "react";
import "./Breadcrumb.css";
import { useNavigate } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  const navigate = useNavigate();

  if (items.length <= 1) return null;

  return (
    <nav className="protrain-breadcrumb" aria-label="Breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && <span className="protrain-breadcrumb-separator">›</span>}
            {isLast || !item.path ? (
              <span className="protrain-breadcrumb-current">{item.label}</span>
            ) : (
              <button className="protrain-breadcrumb-link" onClick={() => navigate(item.path!)}>
                {item.label}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
